export default __webpack_public_path__ + "static/media/slid1.a3844ed6.PNG";